import React from 'react';
import '../styles/Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      title: "Save 20+ Hours Weekly",
      description: "Automate repetitive tasks and focus on strategy instead of execution.",
      icon: "⏱️"
    },
    {
      title: "No Technical Skills Required",
      description: "If you can write an email, you can automate your business with our AI agents.",
      icon: "🔄"
    },
    {
      title: "Scale Marketing Effortlessly",
      description: "Manage hundreds of affiliates and social campaigns simultaneously.",
      icon: "📈"
    },
    {
      title: "Reduce Operating Costs",
      description: "Replace expensive tools and freelancers with our all-in-one platform.",
      icon: "💰"
    },
    {
      title: "Consistent Brand Voice",
      description: "AI learns your brand voice to create authentic content across all channels.",
      icon: "🎯"
    },
    {
      title: "Immediate Implementation",
      description: "Start automating within minutes of getting access, no lengthy setup.",
      icon: "🚀"
    }
  ];

  return (
    <section className="benefits">
      <div className="container">
        <h2>Transform Your Business With <span className="highlight">AI Automation</span></h2>
        <p className="section-subtitle">
          Our users report significant improvements in efficiency, reach, and revenue
        </p>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
        
        <div className="benefits-cta">
          <h3>Ready to revolutionize your business operations?</h3>
          <button 
            onClick={() => document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' })}
            className="primary-button"
          >
            Get Free Access Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
